import React, { useState } from "react"
import { Col, Row } from "react-bootstrap";
import { ReactComponent as ImageCaretRight } from '../../../images/caret-right-fill.svg';
// import ImageGreenCircle from '../../../images/green-circle.png';
import FptProgrammModal from "../../controls/FptProgrammModal";


const ProgrammRaster2025 = (props) => {

    const [programmData, setProgrammData] = useState({
        tag: undefined,
        datum: undefined,
        wochentag: undefined,
        xmlFile: undefined,
        idFpt: undefined
    });

    const [showModal, setShowModal] = useState(false);

    //#region FormEvents

    const bttnDetailTag1Click = () => {
        setProgrammData({
            tag: 'tag1',
            datum: '04.02.2025',
            wochentag: 'Dienstag',
            xmlFile: 'fpt036_tag1.xml',
            idFpt: 'fpt036'
        });
        setShowModal(true);
    }

    const bttnDetailTag2Click = () => {
        setProgrammData({
            tag: 'tag2',
            datum: '05.02.2025',
            wochentag: 'Mittwoch',
            xmlFile: 'fpt036_tag2.xml',
            idFpt: 'fpt036'
        });

        setShowModal(true);
    }

    //#endregion

    return (
        <React.Fragment>
            <Row className='pb-4 pb-lg-0'>
                <Col xs={12} md={6} className='pb-4'>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag1Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Dienstag</strong> 04.02.2025
                        </div>
                        <div className="programm-orange shadow-sm">
                            <br/>
                            Sensorik<br />
                            Messtechnik<br />
                            Prozessautomation<br />
                            Digitalisierung<br />
                            <br />
                        </div>
                        <div className="programm-black shadow-sm">
                            Meet-the-Press Abend
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag2Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Mittwoch</strong> 05.02.2025
                        </div>
                        <div className="programm-orange shadow-sm">
                            <br />
                            Steuerungstechnik & HMI<br />
                            Netzwerke<br />
                            Robotik
                            <br />
                            <br />
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
            </Row>

            {showModal &&
                <FptProgrammModal onClose={() => setShowModal(false)} data={programmData} />
            }

        </React.Fragment>

    )

}
export default ProgrammRaster2025;